import { FC, PropsWithChildren } from 'react';
import { Outlet } from 'react-router-dom';

import { LegalFooter } from '../components/LegalFooter';
import { useResetScrollPositionOnRouteChanges } from '../hooks/useResetScrollPositionOnRouteChanges';

export type AuthLayoutProps = PropsWithChildren;

export const AuthLayout: FC<AuthLayoutProps> = ({ children }) => {
  useResetScrollPositionOnRouteChanges();

  return (
    <div className="flex min-h-screen min-w-[100vw] flex-col items-center justify-center bg-auth-background">
      <>
        {children ?? <Outlet />}
        <footer className="py-4">
          <LegalFooter />
        </footer>
      </>
    </div>
  );
};
